import React, { useEffect, useState } from 'react';
import TabHeaderItem from './tab-header-item';

import { navigate } from '@reach/router';
import { generateRouteUrl } from '../../utils/core';
import { connect } from 'react-redux';
import { tabDetailsObjects } from '../../config/admin';

const wrapperRef = React.createRef();
const innerRef = React.createRef();

const Tabs = ({ editors, tenantId }) => {

    const [hideCloseButtons, setHideCloseButtons] = useState(false);
    const [hideTitles, setHideTitles] = useState(false);

    const openTab = (key) => {
        const editor = editors.find(e => e.key === key);
        const tabs = tabDetailsObjects;
        const slug = editor.type === 'flow' || editor.type === 'page' || editor.type === 'new_page' ? editor.type : Object.values(tabs).find(t => t.name === editor.type).slug;
        const route = generateRouteUrl({
            tenantId,
            tabType: slug,
            options: {
                tabKey: key,
                pageId: editor.pageId,
                flowId: editor.flowId,
            },
        });
        navigate(route);
    };

    const recalculateHidingCloseButtons = () => {
        const wrapperWidth = wrapperRef.current.clientWidth;

        const elements = document.getElementsByClassName('tab-header-item');
        
        // if wrapper width can't fit the elements x100px
        // then hide the close button for tabs other than the active
        setHideCloseButtons(elements.length * 100 >= wrapperWidth);

        // if wrapper width can't fit the elements x75px
        // then hide the title and icons for all tabs
        setHideTitles(elements.length * 75 >= wrapperWidth);
    };

    window.addEventListener('resize', () => {
        recalculateHidingCloseButtons();
    });

    useEffect(() => {
        recalculateHidingCloseButtons();
    }, [editors]);

    const onSelect = (e) => {
        openTab(e.currentTarget.getAttribute('data-tab-key'));
    };

    return (
        <div ref={wrapperRef} className="tab-header-items-wrapper">
            <div ref={innerRef} className="tab-header-items">
                {
                    editors && editors.map(
                        editor => <TabHeaderItem key={editor.id} editor={editor} onSelect={onSelect} hideCloseButtons={hideCloseButtons} hideTitles={hideTitles} />,
                    )
                }
            </div>
        </div>
    );
};

const mapStateToProps = ({ currentUser: { tenantId } }) => ({ tenantId });

export default connect(mapStateToProps)(Tabs);
